import React from 'react'
import parse from 'html-react-parser'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate, getContentFromCS } from 'src/utils'
import { Row, Col, Button } from 'react-bootstrap'
import { pageNames } from 'src/routes/pathParams'
import { getFilterParams } from 'src/deps'
import {
  customerContainer,
  orderHistoryContainer,
  userContainer,
  cartContainer,
} from 'src/models'
import { APPConfig } from 'config/appConfig'
import { OrderCard } from './OrderCard'
import { OrderSearch } from './orderSearch'
import { OrderHistoryFooter } from './OrderHistoryFooter'
import { searchDate, orderFilterStatus } from './fixture'
import ReorderView from './ReorderView'
import {
  IoIosArrowForward as ArrowForwardIcon,
  IoIosArrowBack as ArrowBackwardIcon,
} from 'react-icons/io'
import OtherUsersList from '../Subscriptions/OtherUsersList'
import {
  IS_BROWSER,
  getLocalStorage,
  isB2BAdmin,
  trackGTMEvents,
  getLiveEventStatus,
  convertToBoolean,
} from 'src/utils'
import { MetaDecorator } from 'src/views/components'
import { scrollUtilities } from 'src/utils/customScrollManager'

@observer
class MyAccountOrders extends React.Component {
  constructor(props) {
    super(props)
  }
  @observable orderList = []
  @observable reOrderList = []
  @observable isReorderView = false
  @observable costCenterId = ''
  @observable isActive = false
  @observable activeIndex = -1
  @observable page = 1
  @observable totalCount = 1
  // holds currently open accordion block order history id
  @observable activeBlockId = ''
  @observable userList = []
  @observable filteredOption = []
  @observable selectedUser = {}
  @observable isUserChanged = false
  @observable username = ''
  @observable selectedOrderId = ''
  @observable isLoading = false
  @observable pbomSkuIds = []
  paginationLimit = 10

  static defaultProps = {
    totalCount: 3,
    defaultTitle: ['image', 'name', 'color', 'size', 'fit'],
  }

  getPbomSkuIdsFromCS = async () => {
    const csContent = await getContentFromCS('storefront_csr_translations_3')
    this.pbomSkuIds = csContent?.orderPbomSkuids.ids
  }

  initializeOrderHistoryFlow = () => {
    const customerResponse =
      customerContainer?.profileResponse?.customer ||
      customerContainer?.profileResponse
    if (customerResponse?.id) {
      this.fetchOrderList(true)
    } else {
      setTimeout(() => {
        this.initializeOrderHistoryFlow()
      }, 300)
    }
  }

  componentDidMount() {
    cartContainer.isOrderIdAndRestrictionCallInProgress = true
    const firstName = customerContainer.profileResponse?.firstName || ''
    const lastName = customerContainer.profileResponse?.lastName || ''
    this.username = firstName ? `${firstName + ' ' + lastName}` : ''
    this.initializeOrderHistoryFlow()
    if (this.pbomSkuIds.length === 0) {
      this.getPbomSkuIdsFromCS()
    }
    scrollUtilities.scrollToTop('my-account-details-wrapper')
  }

  componentDidUpdate(prevProps) {
    try {
      if (
        JSON.stringify(prevProps?.location) !==
        JSON.stringify(this.props?.location)
      ) {
        this.fetchOrderList()
      }
    } catch (error) {
      console.error('Error in JSON.stringify')
    }
  }

  fetchOrderList = async (initialLoad = false) => {
    await this.getOrderListData()
    if (IS_BROWSER && initialLoad) {
      const previousURL =
        getLocalStorage('prevPageUrl') || this.props.location?.state?.from || ''
      if (previousURL.includes(pageNames.orderConfirmation)) {
        this.activeBlockId =
          this.orderList?.[0]?.orderInfo?.orderDetails?.id || ''
        const orderItems =
          this.orderList?.[0]?.orderInfo?.orderDetails?.orderItems || []
        const payload =
          await orderHistoryContainer.getPayloadDataForForeignOrderLimitAPI(
            orderItems
          )
        await cartContainer.getForeignOrderLimitRestriction(payload)
      }
    }
  }

  getOrderListData = async () => {
    this.isLoading = true
    const isOtherUsers = orderHistoryContainer.otherUsers
    const queryParams = getFilterParams(this.props?.location) || {}

    let refineParams
    try {
      refineParams = queryParams.refine
        ? {
            ...JSON.parse(queryParams.refine),
          }
        : {}
    } catch (e) {
      console.error('JSON.parse may be an error >>> getOrderListData', e)
    }

    const params = {
      page: queryParams.page || this.page,
      size: this.paginationLimit,
    }
    const orderId = refineParams?.refine?.orderId
    if (isOtherUsers) {
      if (this.userList && this.userList.length == 0) {
        const userParams = {
          page: 1,
          size: 50,
        }
        let users = (await userContainer.getUsersList(userParams)) || {}
        this.userList = users?.accountBuyer || []
        this.userList = this.userList.filter(
          ({ buyerInfo = {} }) =>
            buyerInfo.id !== customerContainer.userId &&
            buyerInfo.status === 'ACTIVE'
        )
        this.filteredOption = this.userList || []
      }
      if (!this.isUserChanged && this.userList && this.userList.length) {
        this.selectedUser = this.userList[0]
      }
    } else {
      this.isUserChanged = false
      this.selectedUser = {}
    }
    if (orderId && !isOtherUsers) {
      await this.getOrderById(orderId)
    } else {
      const orderRefineData =
        refineParams && this.constructOrderRefineParams(refineParams)
      await this.getAllOrders(orderRefineData, params)
    }
    this.isLoading = false
  }

  getAllOrders = async (orderRefineData, params) => {
    let orders = await orderHistoryContainer.getAllOrders(
      orderRefineData,
      params
    )
    this.orderList = orders?.orders || []
    this.totalCount = orders?.pageableInfo?.totalCount || 1

    //------ dataLayer Object to push Users Order history--------
    const enableLiveEvent = getLiveEventStatus()
    if (enableLiveEvent === 'true') {
      trackGTMEvents({
        event: 'view_order_history',
      })
    }

    trackGTMEvents({
      event: 'nuskin-profile',
      eventType: 'orderHistory',
    })
    // const user = customerContainer.profileResponse || {}
    // TagManager.dataLayer({
    //   dataLayer: {
    //     event: 'orderHistory',
    //     pagePath: '/myaccount/orderhistory',
    //     pageTitle: 'Order History',
    //     orders: this.orderList,
    //     userInfo: {
    //       id: user.id,
    //       firstName: user.firstName,
    //       lastName: user.lastName,
    //       email: user.email,
    //       phoneNumber: user.phoneNumber,
    //     },
    //     platform: 'equinox',
    //   },
    // })
  }
  getOrderById = async orderId => {
    cartContainer.isOrderIdAndRestrictionCallInProgress = true
    this.orderList = []
    this.reOrderList = []
    let response = orderHistoryContainer.orderDetailsByIdResponse || {}
    if (response?.orderInfo?.orderDetails?.id != orderId) {
      response = await orderHistoryContainer.getOrderById(orderId)
      const orderItems = response?.orderInfo?.orderDetails?.orderItems || []
      const payload =
        orderHistoryContainer.getPayloadDataForForeignOrderLimitAPI(orderItems)
      await cartContainer.getForeignOrderLimitRestriction(payload)
    }
    if (response?.orderInfo?.orderDetails?.id) {
      this.orderList = [response]
      this.reOrderList = response?.orderInfo?.orderDetails?.orderItems || []
      this.totalCount = 1
    }
    cartContainer.isOrderIdAndRestrictionCallInProgress = false
  }

  onInputChange = event => {
    this.filteredOption = this.userList.filter((userObj = {}) => {
      const option = `${userObj.buyerInfo?.firstName || ''} ${
        userObj.buyerInfo?.lastName || ''
      }`.toLowerCase()
      return option.indexOf(event.target.value) > -1
    })
  }

  handleUserChange = user => {
    let month = this.props?.location?.queryParams?.month || ''
    let showAll = false
    if (month == 'showall') {
      month = ''
      showAll = true
    }
    this.selectedUser = user
    this.isUserChanged = true
    this.getOrderListData()
  }
  calculateDurationToRefine = props => {
    const dateLimit = props ? props.toString() : ''
    const date = {
      fromdate: '',
      todate: '',
    }
    if (dateLimit && dateLimit !== 'All') {
      const today = new Date()
      const fromDate = new Date().setMonth(today.getMonth() - dateLimit)
      const toDate = today.getTime()
      date.fromdate = fromDate.toString()
      date.todate = (toDate + 5 * 60 * 1000).toString()
    }
    return date
  }
  constructOrderRefineParams = refineParams => {
    const { status = '', dateLimit = '1' } = refineParams?.refine || {}
    const date = this.calculateDurationToRefine(dateLimit) || {}
    let filterParams = ''
    if (status && dateLimit) {
      filterParams = `status:${status},createdTime<${date.todate},createdTime>${date.fromdate}`
    } else {
      if (status) {
        filterParams = `status:${status}`
      }
      if (dateLimit) {
        filterParams = `createdTime<${date.todate},createdTime>${date.fromdate}`
      }
    }
    if (orderHistoryContainer.otherUsers && this.userList?.length > 0) {
      const orderId = refineParams?.refine?.orderId
      if (filterParams)
        filterParams += `,usertracking.userid:${
          this.selectedUser?.buyerInfo?.id
        }${orderId ? `,id:${orderId}` : ''}`
      else
        filterParams = `,usertracking.userid:${
          this.selectedUser?.buyerInfo?.id
        }${orderId ? `,id:${orderId}` : ''}`
    } else if (!orderHistoryContainer.otherUsers) {
      if (filterParams) {
        filterParams += `,usertracking.userid:${customerContainer.userId}`
      } else {
        filterParams = `,usertracking.userid:${customerContainer.userId}`
      }
    }
    return filterParams
  }

  handleReorder = (event, reOrderList, costCenterId, orderId) => {
    event.preventDefault()
    event.stopPropagation()
    /*
     * Commented below line to prevent reordering clicks before getOrderId call
     * and made this call from reorderview
     * so that updated order id details will be applied
     */
    //this.getOrderById(orderId)
    if (reOrderList?.length) {
      this.reOrderList = reOrderList
      this.costCenterId = costCenterId
      this.isReorderView = true
    }

    this.selectedOrderId = orderId
  }

  toggleAccordionView = (orderId = '') => {
    if (this.activeBlockId?.includes(orderId) || orderId === '') {
      this.activeBlockId = ''
    } else {
      this.activeBlockId = orderId
    }
  }

  renderOrderCardView = () => {
    if (this.isLoading) return null
    const { location = {} } = this.props

    let refineParams = {}
    try {
      refineParams = getFilterParams(location)?.refine
        ? JSON.parse(getFilterParams(location)?.refine)?.refine
        : {}
    } catch (e) {
      console.error('JSON.parse may be an error >> renderOrderCardView ', e)
    }

    if (
      this.orderList &&
      this.orderList.length > 0 &&
      (!orderHistoryContainer.otherUsers ||
        (orderHistoryContainer.otherUsers &&
          this.userList &&
          this.userList.length > 0))
    ) {
      const orderCardView = this.orderList.map((item, index) => {
        const isPBOMOrder = item?.orderInfo?.orderDetails?.orderItems?.some(
          item =>
            item?.item?.itemInfo?.sku?.skuId &&
            this.pbomSkuIds.includes(item.item.itemInfo.sku.skuId)
        )
        return (
          <OrderCard
            key={index}
            index={index}
            orderDetails={item}
            toggleAccordionView={this.toggleAccordionView}
            activeBlockId={this.activeBlockId}
            onReorder={this.handleReorder}
            addLiveEventLabel={true}
            isPBOMOrder={isPBOMOrder}
            {...this.props}
          />
        )
      })
      return orderCardView
    } else if (
      orderHistoryContainer.otherUsers &&
      this.userList &&
      this.userList.length == 0
    ) {
      return (
        <div className="px-3 pb-4">
          {i18nTranslate('orders.noUsers', 'No users found.')}
        </div>
      )
    } else if (Object.keys(refineParams).length > 0) {
      return (
        <div className="px-3 pb-4" role="alert">
          {i18nTranslate(
            'orders.refineNoProducts',
            'No orders found matching your filter params.'
          )}
        </div>
      )
    } else {
      return (
        <div className="px-3 pb-4">
          {i18nTranslate(
            'orders.noOrders',
            'You currently have no orders available. Recently placed orders will appear here.'
          )}
        </div>
      )
    }
  }

  getSelectedParam = (filterObject, selectedParam) => {
    const key = filterObject.find(item => {
      return item?.value?.toString() === selectedParam ? true : false
    })?.key
    return key
  }

  handleBack = () => {
    this.isReorderView = false
    this.getOrderListData()
    this.toggleAccordionView()
  }
  renderReorderView = () => {
    if (typeof window === 'object') {
      window.scrollTo(0, 0)
    }
    const title = i18nTranslate(
      'orderHistory.reorderBackTitle',
      'Order History'
    )
    return (
      <ReorderView
        orderList={this.reOrderList}
        costCenterId={this.costCenterId}
        handleBack={this.handleBack}
        title={title}
        selectedOrderId={this.selectedOrderId}
        handleOrderIdCall={this.getOrderById}
        {...this.props}
      />
    )
  }
  renderTitleView = () => {
    const orderHistoryTitle = i18nTranslate(
      'orderHistory.headerTitle',
      'Your Orders'
    )
    return orderHistoryTitle
  }

  resetFilters = () => {
    this.props.history.push(pageNames?.myaccountorders || '')
  }

  renderOrderView = () => {
    //totalCount is missing in api response//
    //pagination : waiting for total count
    const { location = {} } = this.props

    let refineParams = {}

    try {
      refineParams = getFilterParams(location).refine
        ? JSON.parse(getFilterParams(location)?.refine)?.refine
        : {}
    } catch (e) {
      console.error('JSON.parse may be an error >> renderOrderView ', e)
    }

    const allTitle = i18nTranslate('orderhistory.alltitle', 'All')
    const selectedStatus = refineParams.status
      ? this.getSelectedParam(orderFilterStatus, refineParams.status)
      : allTitle
    const selectedDate = refineParams.dateLimit
      ? this.getSelectedParam(searchDate, refineParams.dateLimit)
      : i18nTranslate('orderSearch.oneMonth', 'Last 1 Month')
    const selectedOrderId = refineParams.orderId
    const noOfPages =
      this.totalCount >= 1
        ? Math.ceil(this.totalCount / this.paginationLimit)
        : 1 //no of pages
    const paginationDropBox = [...Array(noOfPages).keys()].map(i => i + 1)
    const myAccountOrderHistoryTitle = i18nTranslate(
      'myAccountOrderHistoryPage.title',
      'Order History | Nu Skin'
    )
    const enableLiveEvent = getLiveEventStatus()
    const enableOnlineReturnMFE =
      convertToBoolean(APPConfig?.getAppConfig()?.enableOnlineReturnMFE) ||
      false
    const euaEnhancedReturnsExperience =
      convertToBoolean(
        APPConfig?.getAppConfig()?.euaEnhancedReturnsExperience
      ) || false
    return (
      <>
        <MetaDecorator
          title={myAccountOrderHistoryTitle}
          imageUrl=""
          imageAlt=""
          description="Order History Page"
          location={this.props}
        />
        <div>
          <div
            className="order-history-header bg-white p-3 shadow-sm"
            data-testid="qa-order-container">
            <h1
              className="d-inline heading-2"
              data-testid="qa-order-history-heading">
              {this.renderTitleView()}
            </h1>
            {isB2BAdmin() && (
              <Row
                noGutters
                className={`month-list-header d-flex justify-content-center text-uppercase pb-3 bg-white pt-3`}>
                <Col
                  className={`subsctription-tabs pr-3 ${
                    orderHistoryContainer.otherUsers ? '' : 'selected'
                  }`}
                  data-testid={`qa-user-sub-upcoming-delivery-month`}>
                  {/* <Link
                    onClick={() => {
                      orderHistoryContainer.otherUser(false)
                      this.getOrderListData()
                    }}>
                    {i18nTranslate('orders.myOrders', 'My Orders')}
                  </Link> */}
                </Col>
                {customerContainer?.profileResponse?.accounts?.accountType ===
                'Retail Customer' ? (
                  ''
                ) : (
                  <Col
                    className={`subsctription-tabs ${
                      orderHistoryContainer.otherUsers ? 'selected' : ''
                    }`}
                    data-testid={`qa-user-sub-upcoming-delivery-month`}>
                    {/* <Link
                      onClick={() => {
                        orderHistoryContainer.otherUser(true)
                        this.fetchOrderList()
                      }}>
                      {i18nTranslate(
                        'orders.myAssociateOrders',
                        "My Associate's Orders"
                      )}
                    </Link> */}
                  </Col>
                )}
              </Row>
            )}
            {/* {this.userList && this.userList.length > 0 && orderHistoryContainer.otherUsers && (
              <OtherUsersList
                options={this.filteredOption}
                onInputChange={this.onInputChange}
                handleUserChange={this.handleUserChange}
                defaultUser={this.selectedUser}
              />
            )} */}
            {this.userList &&
              this.userList.length > 0 &&
              orderHistoryContainer.otherUsers && (
                <Row noGutters className="justify-content-end mb-4">
                  <Col lg={3}>
                    <OtherUsersList
                      options={this.filteredOption}
                      onInputChange={this.onInputChange}
                      handleUserChange={this.handleUserChange}
                      defaultUser={this.selectedUser}
                    />
                  </Col>
                </Row>
              )}
            {enableLiveEvent !== 'true' && (
              <>
                <OrderSearch
                  {...this.props}
                  selectedDate={selectedDate}
                  selectedStatus={selectedStatus}
                  getOrderListData={this.getOrderListData}
                  selectedOrderId={selectedOrderId}
                  toggleAccordionView={this.toggleAccordionView}
                />
                {enableOnlineReturnMFE && (
                  <div className="mt-2">
                    {i18nTranslate(
                      'order_history_subtitle',
                      '**Items having “Completed“ status only are eligible for return**'
                    )}
                    {euaEnhancedReturnsExperience && (
                      <div className="mt-2">
                        <div>
                          {parse(
                            i18nTranslate(
                              'order_history_info',
                              'You may exercise your 14-days right to withdraw by using the return feature when available.'
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
            {Object.keys(refineParams).length > 0 && (
              <Button
                variant=""
                className="text-primary d-block ml-auto"
                onClick={this.resetFilters}>
                {i18nTranslate('order.resetFilter', 'Reset Filters')}
              </Button>
            )}
          </div>
          <Row noGutters data-testid="qa-orders-container" className="mt-2">
            {this.renderOrderCardView()}
          </Row>
          {this.orderList && this.orderList.length > 0 ? (
            <div className="order-history-pagination d-flex align-items-center justify-content-end">
              <div className="order-history-selectBox-container">
                <select
                  className="order-history-selectBox"
                  aria-label="order history selectbox"
                  value={this.page}
                  data-testid="qa-order-history-page-select-box"
                  onChange={event => {
                    this.page = event.target.value
                    this.fetchOrderList()
                  }}>
                  {paginationDropBox?.map(item => {
                    return (
                      <option
                        key={item}
                        value={item}
                        data-testid={`qa-order-history-page-${item}`}>
                        {item}
                      </option>
                    )
                  })}
                </select>
              </div>
              <ArrowBackwardIcon
                className={`order-history-backward-arrow ${
                  this.page == 1 ? ' disabled' : ''
                }`}
                data-testid="qa-order-history-next-page"
                onClick={event => {
                  if (this.page != 1) {
                    this.page = this.page - 1
                    this.fetchOrderList()
                  }
                }}
              />
              <ArrowForwardIcon
                className={`order-history-forward-arrow ${
                  this.page == noOfPages ? ' disabled' : ''
                }`}
                data-testid="qa-order-history-previous-page"
                onClick={() => {
                  if (this.page != noOfPages) {
                    this.page = +this.page + 1
                    this.fetchOrderList()
                  }
                }}
              />
              <div
                className="order-history-pagination-text"
                data-testid="qa-order-history-pagination-text">
                {i18nTranslate('order.page', 'page')}&nbsp;
                {`${this.page}`}&nbsp;
                {i18nTranslate('order.of', 'of')}&nbsp;
                {`${noOfPages}`}
              </div>
            </div>
          ) : null}
        </div>
        <OrderHistoryFooter {...this.props} />
      </>
    )
  }

  render() {
    return this.isReorderView
      ? this.renderReorderView()
      : this.renderOrderView()
  }
}

export { MyAccountOrders }
export default MyAccountOrders
